module.exports = __webpack_public_path__ + "static/media/vodafone-bold.e470bb51.woff";